module.exports = __webpack_public_path__ + "img/巴旦杏仁.2ea1db33.jpg";